import HoumaHeroSection from "./components/HeroSection";
import HoumaStickyNav from "./components/StickyNav";
import HoumaProcessingTimeSection from "./components/ProcessingTimeSection";
import HoumaServicesSection from "./components/ServicesSection";
import HoumaLocalAreaSection from "./components/LocalAreaSection";
import HoumaTestimonialsSection from "./components/TestimonialsSection";
import HoumaAcceptanceFacilitiesSection from "./components/AcceptanceFacilitiesSection";
import HoumaComparisonSection from "./components/ComparisonSection";
import HoumaMistakesSection from "./components/MistakesSection";
import HoumaHowItWorksSection from "./components/HowItWorksSection";
import HoumaFAQSection, { faqs } from "./components/FAQSection";
import HoumaHelpfulResourcesSection from "./components/HelpfulResourcesSection";
import HoumaFinalCTA from "./components/FinalCTA";
import HoumaTravelTimingSection from "./components/TravelTimingSection";
import HoumaDestinationsSection from "./components/DestinationsSection";
import CitySEOHead from "@/components/feature/CitySEOHead";
import SEOCrossLinks from "@/components/feature/SEOCrossLinks";

const faqsMapped = faqs.map((f: { q: string; a: string }) => ({ q: f.q, a: f.a }));

export default function HoumaPage() {
  return (
    <div className="font-sans">
      <CitySEOHead
        city="Houma"
        state="Louisiana"
        stateAbbr="LA"
        route="/houma"
        title="Emergency Passport Houma, LA — Expedited & Fast Passport Service | Fast Passport Center"
        description="Emergency and expedited passport services in Houma, LA — as fast as 24 hours. Serving offshore workers, fishing industry travelers, and families in Terrebonne Parish. A+ BBB rated, registered State Dept. courier."
        geoPlacename="Houma, Louisiana"
        geoPosition="29.5958;-90.7195"
        faqs={faqsMapped}
        servicesSchema={[
          { name: "Emergency Passport", description: "Urgent passport processing for Houma travelers with immediate departure needs — as fast as 24 hours for Terrebonne Parish residents." },
          { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens in Houma with an expired or expiring passport." },
          { name: "New Passport", description: "First-time passport application assistance for Houma families and offshore workers." },
          { name: "Lost or Stolen Passport", description: "Passport replacement for lost or stolen passports with DS-64 form guidance in Houma, LA." },
          { name: "Child Passport", description: "Passport services for minors under 16 with parental consent guidance for Terrebonne Parish families." },
          { name: "Name Change", description: "Passport correction and name change service for Houma residents after marriage or legal changes." },
          { name: "Second Passport", description: "Second passport service for offshore workers and fishing industry travelers from Houma." },
        ]}
        statePageName="Louisiana"
        statePageRoute="/states/louisiana"
      />
      <HoumaHeroSection />
      <HoumaStickyNav />
      <HoumaProcessingTimeSection />
      <HoumaLocalAreaSection />
      <HoumaServicesSection />
      <HoumaTravelTimingSection />
      <HoumaDestinationsSection />
      <HoumaTestimonialsSection />
      <HoumaAcceptanceFacilitiesSection />
      <HoumaComparisonSection />
      <HoumaMistakesSection />
      <HoumaHowItWorksSection />
      <HoumaFAQSection />
      <HoumaHelpfulResourcesSection />
      <SEOCrossLinks currentRoute="/cities/houma" state="LA" />
      <HoumaFinalCTA />
    </div>
  );
}